import { ReleaseMemberText, ReleaseTextList } from "./styled";
import Typography from "../Typography";
import { useGetTextFileQuery } from "../../api/podcastsApi";
import { Center } from "../../App/styled";
import Loader from "../Loader/Loader";
import parse from "html-react-parser";

export const ReleaseText = ({ releaseTextLink }) => {
  const {
    data: releaseText,
    isLoading,
    isError,
  } = useGetTextFileQuery(releaseTextLink);

  if (isLoading) {
    return (
      <Center>
        <Loader color="#fff" />
      </Center>
    );
  }

  if (isError) {
    return <div>Ошибка при загрузке текста</div>;
  }

  return (
    <ReleaseTextList>
      <li>
        <Typography as={ReleaseMemberText}>{parse(releaseText)}</Typography>
      </li>
    </ReleaseTextList>
  );
};
